import { HeapScript } from '../../../components/head/scripts/heap'
import { ImpactUttHeadScript } from './Impact'
import { Routes } from '@dtx-company/true-common/src/constants/routes'
import React from 'react'

export const AppHeadContents: React.FC<{
  pathname: string
  page?: { links: { type: string }[] }
}> = ({ pathname, page }) => {
  const isFlowpage = pathname === Routes.FLOWPAGE
  const hasNBAWidget = page?.links?.some(link => link.type === 'nbaIdGate')
  return (
    <>
      {isFlowpage ? (
        <>
          {/* Add checks for additional 3rd party gate widget scripts here */}
          {hasNBAWidget && (
            <script // NBA ID Widget
              data-testid="nba-id-widget"
              async
              src="https://s3.us-east-1.amazonaws.com/static.widgets.nba.com/v1/uvwidget.js"
            />
          )}
        </>
      ) : (
        <>
          <HeapScript />
          <ImpactUttHeadScript />
        </>
      )}
    </>
  )
}
